import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App.tsx'
import MentionsLegales from './pages/MentionsLegales.tsx'
import Confidentialite from './pages/Confidentialite.tsx'
import './index.css'

const router = createBrowserRouter([
  { path: '/', element: <App /> },
  { path: '/mentions-legales', element: <MentionsLegales /> },
  { path: '/politique-de-confidentialite', element: <Confidentialite /> },
])

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
